import classnames from 'classnames';

export const themes = {
  default: () => ({
    thRoot: 'flex flex-wrap -m-px',
    thButton:
      'cursor-pointer bg-blue focus:bg-turquoise hover:bg-turquoise capitalize flex flex-1 font-bold items-center justify-center m-px px-4 py-3 text-base text-white transition-bg-color w-full',
    thButtonActive:
      'cursor-default bg-turquoise focus:bg-turquoise hover:bg-turquoise capitalize flex flex-1 font-bold items-center justify-center m-px pointer-events-none px-4 py-3 text-base text-white transition-bg-color w-full',
    thIcon: 'rtl:mr-2',
    thIconSize: '1.625rem',
    thText: 'text-initial',
    thNumber: 'block leading-one',
  }),
  overlay: ({ isScrollable }) => ({
    thRoot: classnames({
      'flex flex-wrap justify-center -m-px': !isScrollable,
      'flex overflow-x-scroll sm:overflow-hidden': isScrollable,
    }),
    thButton:
      'cursor-pointer bg-white focus:bg-overlay-black-60 hover:bg-overlay-black-60 capitalize flex font-bold items-center justify-between mx-1 p-2 rounded-tiny text-sm text-gray focus:text-white hover:text-white transition-all',
    thButtonActive:
      'cursor-default bg-overlay-black-60 focus:bg-overlay-black-60 hover:bg-overlay-black-60 capitalize flex font-bold items-center justify-between mx-1 p-2 pointer-events-none rounded-tiny text-sm text-white transition-all',
    thIcon: 'flex-shrink-0 rtl:mr-1 overflow-visible',
    thIconSize: '1rem',
    thText: 'flex flex-row-reverse font-bold justify-between w-full text-initial',
    thNumber: 'rtl:pl-1',
  }),
};
